import { render, staticRenderFns } from "./KaijuPayoutModal.vue?vue&type=template&id=79e9aa16&"
import script from "./KaijuPayoutModal.vue?vue&type=script&lang=ts&"
export * from "./KaijuPayoutModal.vue?vue&type=script&lang=ts&"
import style0 from "./KaijuPayoutModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports